import * as React from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import DrawerComponent from "../../components/DrawerComponent/DrawerComponent";
import AppBarComponent from "../../components/AppBarComponent/AppBarComponent";
import AsignacionDisenadorPanel from "../../components/Proyectos/AsignacionDisenadorPanel";

export default function AsignacionDisenadorPage() {
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      <CssBaseline />
      <AppBarComponent
        open={open}
        handleDrawerOpen={() => setOpen((p) => !p)}
        auth
        anchorEl={anchorEl}
        handleMenu={(e) => setAnchorEl(e.currentTarget)}
        handleClose={() => setAnchorEl(null)}
        title="Asignación de diseñador"
      />
      <DrawerComponent open={open} handleDrawerClose={() => setOpen(false)} />
      <Box component="main" sx={{ flexGrow: 1, overflow: "auto", pt: "116px", pb: "56px" }}>
        <Container maxWidth="xl" sx={{ mt: 1 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <AsignacionDisenadorPanel />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
}
